module.exports = __webpack_public_path__ + "./img/avatar-3.6f6bbc61dbca9707b7ce2dd0525f8608.webp";